import { render } from "./decorate.vue?vue&type=template&id=509ab884&scoped=true"
import script from "./decorate.vue?vue&type=script&lang=js"
export * from "./decorate.vue?vue&type=script&lang=js"

import "./decorate.vue?vue&type=style&index=0&id=509ab884&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509ab884"]])

export default __exports__